<template>
  <v-container fluid class="av-page">
    <div class="av-card av-filtro-card">
      <span class="av-section-label">Empresa</span>
      <v-row dense>
        <v-col cols="12" sm="8" md="6" lg="6">
          <v-autocomplete
            outlined
            dense
            hide-details
            v-model="empresaSelecionada"
            :items="empresas"
            item-text="nome"
            item-value="id"
            placeholder="Selecione a empresa"
            no-data-text="Nenhuma empresa encontrada"
            @input="carregaUsuarios()"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </div>

    <div class="av-card av-panel">
      <div class="av-toolbar">
        <v-text-field
          v-model="tabela.busca"
          append-icon="search"
          label="Procurar"
          outlined
          dense
          hide-details
          single-line
          class="av-busca"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="primary"
          :disabled="empresaSelecionada == ''"
          @click="abrirNovo"
        >
          <v-icon left>add</v-icon>Novo usuário
        </v-btn>
      </div>

      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        sort-by="nome"
        class="av-table"
        :footer-props="{
          'items-per-page-text': 'Linhas por página',
          'items-per-page-all-text': 'Tudo',
        }"
        :loading="tabela.carregamento"
        loading-text="Buscando itens..."
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="editItem(item)">
                <v-icon small color="primary">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="deleteItem(item)">
                <v-icon small color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <v-chip small label :color="item.ativo ? 'success' : 'error'" text-color="white">
            {{ item.ativo ? 'Ativo' : 'Inativo' }}
          </v-chip>
        </template>
        <template v-slot:[`item.tipo`]="{ item }">
          <span v-if="item.tipo == 'ADMIN'">Administrador</span>
          <span v-else-if="item.tipo == 'GERENTE'">Gerente</span>
          <span v-else>{{ item.tipo }}</span>
        </template>
        <template v-slot:no-data>
          <v-alert v-if="empresaSelecionada == ''" dense text outlined type="info" class="my-4">
            Selecione uma empresa para visualizar os usuários
          </v-alert>
          <v-alert v-else dense text outlined type="warning" class="my-4">
            Nenhum usuário cadastrado
          </v-alert>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="dialogoUsuario" persistent max-width="520px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">{{ formTitle }}</v-card-title>
        <p class="av-dialog-hint">* indica preenchimento obrigatório</p>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="12">
              <v-text-field label="Nome*" outlined dense v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="E-mail*" outlined dense v-model="editedItem.email"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Senha*" outlined dense type="password" v-model="editedItem.password"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select label="Tipo de Usuário*" outlined dense v-model="editedItem.tipo" :items="tiposUsuario" item-text="text" item-value="value"></v-select>
            </v-col>
            <v-col cols="12">
              <div class="av-switch-field">
                <v-checkbox
                  v-model="editedItem.ativo"
                  :label="editedItem.ativo ? 'Ativo' : 'Inativo'"
                  dense
                  hide-details
                  class="av-check ma-0 pa-0"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoUsuario = false">Cancelar</v-btn>
          <v-btn depressed color="primary" @click="salvarUsuario" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn depressed color="primary" @click="editarUsuario" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#2f7d74" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'E-mail', value: 'email' },
          { text: 'Tipo', value: 'tipo' },
          { text: 'Ativo', value: 'ativo' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      tiposUsuario: [
        // { text: 'Administrador', value: 'ADMIN' },
        { text: 'Gerente', value: 'GERENTE' },
      ],
      dialogoUsuario: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        email: '',
        password: '',
        tipo: '',
        imagem: '',
        empresaId: '',
        ativo: true,
      },
      defaultItem: {
        nome: '',
        email: '',
        password: '',
        tipo: '',
        imagem: '',
        empresaId: '',
        ativo: true,
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo usuário' : 'Editar usuário'
      },
    }),

    watch: {
      dialogoUsuario(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      }
    },

    mounted() {
      this.carregaEmpresas()
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaUsuarios () {
        this.tabela.conteudo = []
        this.isLoading = true
        this.tabela.carregamento = true
        await axios.get(baseApiUrl + 'Usuarios?filter={"where":{"empresaId":"' + this.empresaSelecionada + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
          this.isLoading = false
        })
      },

      abrirNovo() {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialogoUsuario = true
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoUsuario = true
        this.isLoading = false
      },

      async salvarUsuario() {
        var vm = this;
        if (this.editedItem.nome || this.editedItem.email || this.editedItem.password || this.editedItem.tipo) {
          this.isLoading = true
          this.editedItem.empresaId = this.empresaSelecionada
          await axios.post(baseApiUrl + 'Usuarios/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoUsuario = false
              vm.$refs.chamaSnackbar.snack("success", "Operação realizada com sucesso!", "white")
              this.carregaUsuarios()
            }
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "#BF4554")
          })
        } else {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("warning", "Preencha os campos para prosseguir", "white")
        }
      },

      async editarUsuario() {
        var vm = this;
        if (this.editedItem.nome || this.editedItem.email || this.editedItem.password || this.editedItem.tipo) {
          this.isLoading = true
          await axios.put(baseApiUrl + 'Usuarios/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoUsuario = false
              vm.$refs.chamaSnackbar.snack("success", "Operação realizada com sucesso!", "white")
              this.carregaUsuarios()
            }
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "#BF4554")
          })
        } else {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("warning", "Preencha os campos para prosseguir", "white")
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o usuário ' + item.nome + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Usuarios/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("success", "Operação realizada com sucesso!", "white")
            this.carregaUsuarios()
          })
        }
      },
    },
  }
</script>

<style scoped>
  .av-page {
    padding: 20px 24px;
  }

  .av-filtro-card {
    padding: 16px;
    margin-bottom: 16px;
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin-bottom: 8px;
  }

  .av-panel {
    padding: 16px 16px 8px;
  }

  .av-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .av-busca { max-width: 280px; }

  @media (max-width: 599px) {
    .av-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .av-toolbar .v-spacer {
      display: none;
    }

    .av-busca {
      max-width: none;
    }

    .av-toolbar .v-btn {
      width: 100%;
    }
  }

  .av-dialog-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--av-text);
    padding-bottom: 2px;
  }

  .av-dialog-hint {
    margin: 0;
    padding: 0 16px 12px;
    font-size: 13px;
    color: var(--av-text-soft);
  }

  /* "Ativo" com aparência de campo, alinhado aos demais inputs */
  .av-switch-field {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.38);
    padding: 6px 12px;
    min-height: 40px;
  }

  ::v-deep .av-check .v-input__slot {
    margin: 0;
  }

  ::v-deep .av-check .v-input__control {
    min-height: auto;
  }

  ::v-deep .av-check .v-label {
    color: rgba(0, 0, 0, 0.7);
  }

  /* Cabeçalho legível, sobrepondo o CSS global herdado das telas legadas */
  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th {
    color: var(--av-text-soft) !important;
    background: #f7f9f9;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    border-bottom: 1px solid var(--av-border) !important;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th,
  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    height: 46px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    border-bottom: 1px solid #eef1f1 !important;
    font-size: 13.5px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr:hover {
    background: #f5f8f8;
  }

  ::v-deep .av-table.v-data-table {
    background: transparent;
  }
</style>
